const theme = {};

theme.palette = {
  // Brand blues from the spec image
  primary: [
    '#0278B5', // 0: Default (Brand Blue)
    '#026AA0', // 1: Darken ~10%
    '#0271AB', // 2: Darken ~5%
    'rgba(2, 120, 181, 0.2)', // 3: Fade 20%
    '#0F8EC6', // 4: Lighten ~12%
    'rgba(2, 120, 181, 0.75)', // 5: Fade 75%
    '#94C7EB', // 6: Light Blue (secondary brand blue)
    '#6FB0DA', // 7: Lighten from brand blue
    '#046A9B', // 8: Darken ~15%
    '#0278B5', // 9: keep brand blue for "algolia" slot compatibility
    '#5FB1E1', // 10: Lighten ~25%
    '#015C8C', // 11: Darken ~22%
    '#014F79', // 12: Darken ~30%
    '#1FA1D6', // 13: Lighten ~20%
  ],

  // Greys / neutrals preserved
  secondary: [
    '#2d3446', // 0: DarkBlue (neutral heading)
    '#f1f3f6', // 1: LightBluish
    '#788195', // 2: LightBlue gray
    '#E4E6E9', // 3
    '#364d79', // 4
    '#202739', // 5
    '#f5f6f8', // 6
    '#e9ebf1', // 7
    '#F6F8FB', // 8
    '#E9EBEE', // 9
    '#1a1a1a', // 10
  ],

  // Accent colors (left as-is except we align green to brand greens below)
  color: [
    '#FEAC01', // 0: Orange
    '#42299a', // 1: Purple
    '#F75D81', // 2: Pink
    '#7ED321', // 3: LimeGreen
    '#39435f', // 4: BlueShade
    '#FFCA28', // 5: Yellow
    '#F2BD1B', // 6: Yellow Darken 5%
    '#3b5998', // 7: Facebook
    '#344e86', // 8: Facebook Darken 5%
    '#dd4b39', // 9: Google Plus
    '#d73925', // 10: Google Plus Darken 5%
    '#e14615', // 11: Auth0
    '#ca3f13', // 12: Auth0
    '#e0364c', // 13: AlizarinCrimson
  ],

  warning: ['#ffbf00'],

  // Success mapped to brand greens
  success: [
    '#6DBF68', // 0: Success (Brand Green – strong)
    '#A5D395', // 1: Soft green (third bar)
    '#95D160', // 2: Mid green (fourth bar)
  ],

  error: ['#f64744', '#EC3D3A', '#FF5B58'],

  grayscale: [
    '#bababa', // 0
    '#c1c1c1', // 1
    '#D8D8D8', // 2
    '#f1f1f1', // 3
    '#F3F3F3', // 4
    '#fafafa', // 5
    '#F9F9F9', // 6
    '#fcfcfc', // 7
    '#eeeeee', // 8
    '#fbfbfb', // 9
    '#f5f5f5', // 10
    '#f7f8f9', // 11
  ],

  text: ['#323332', '#595959', '#979797', '#797979', '#6a6c6a'],

  border: [
    '#e9e9e9',
    '#d8d8d8',
    '#ebebeb',
    '#d3d3d3',
    'rgba(228, 228, 228, 0.65)',
  ],

  calendar: ['#905', '#690', '#a67f59', '#07a', '#dd4a68', '#e90'],
};

theme.fonts = {
  primary: 'Roboto, sans-serif',
  pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
};

export default theme;
